import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

/**
 * Whether the design-system look is on: for the current company (DesignSystemFeature), and on the
 * sign-in pages (Auth/*), which run before anyone is signed in, per environment
 * (config/design-system.php, shared as _designSystemAuthPages; mirrored in app.blade.php).
 *
 * @returns {import('vue').ComputedRef<boolean>}
 */
export const useDesignSystem = () =>
  computed(() => {
    const page = usePage()
    if (page?.props?._features?.['design-system'] === true) {
      return true
    }
    return (
      String(page?.component ?? '').startsWith('Auth/') &&
      page?.props?._designSystemAuthPages === true
    )
  })
